module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-approved-login-requests panel panel-default",
    attrs: {
      "data-infinite-scroll": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('panel-search', {
    staticClass: "panel-search-light",
    attrs: {
      "placeholder": "Введите IMEI, логин, e-mail или телефон для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.login_requests), function(login_request) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date_format")(login_request.created_at, 'DD.MM.YYYY HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(login_request.user.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(login_request.imei))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(login_request.user.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(login_request.user.email))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "btn btn-sm btn-delete",
      attrs: {
        "href": ("/login-requests/" + (login_request.login_request_id) + "/deactivate")
      }
    }, [_vm._v("Деактивировать")])])])
  }), _vm._v(" "), (_vm.login_requests != null && _vm.login_requests.length < 1) ? _c('tr', [_c('td', {
    staticClass: "info-zero-request",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Нет одобренных заявок")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.next_page_url) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("Еще")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', [_vm._v("История")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Вход в")]), _vm._v(" "), _c('th', [_vm._v("Логин")]), _vm._v(" "), _c('th', [_vm._v("Устройство (IMEI)")]), _vm._v(" "), _c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Действие")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75a459b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a459b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListApprovedLoginRequests.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-75a459b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListApprovedLoginRequests.vue
// module chunks = 0